import React, { cloneElement } from 'react';
import { Section, FadeIn } from './ui';
import { Wand2Icon, ClipboardListIcon, LayoutDashboardIcon, CalendarDaysIcon, ThumbsUpIcon, HeartPulseIcon, NetworkIcon, GraduationCapIcon, MessageSquareQuoteIcon, CheckSquareIcon, PieChartIcon } from 'lucide-react';
export function Features() {
  const features = [{
    icon: <Wand2Icon data-id="element-2682" />,
    title: 'AI Offsite Designer'
  }, {
    icon: <ClipboardListIcon data-id="element-2683" />,
    title: 'Branded Attendee Intake'
  }, {
    icon: <LayoutDashboardIcon data-id="element-2684" />,
    title: 'Event Hub'
  }, {
    icon: <CalendarDaysIcon data-id="element-2685" />,
    title: 'Agenda Builder'
  }, {
    icon: <ThumbsUpIcon data-id="element-2686" />,
    title: 'Activity Preference Capture'
  }, {
    icon: <HeartPulseIcon data-id="element-2687" />,
    title: 'Wellness Preferences'
  }, {
    icon: <NetworkIcon data-id="element-2688" />,
    title: 'Networking and Group Matching'
  }, {
    icon: <GraduationCapIcon data-id="element-2689" />,
    title: 'Learning Pathways'
  }, {
    icon: <MessageSquareQuoteIcon data-id="element-2690" />,
    title: 'Reflection Prompts'
  }, {
    icon: <CheckSquareIcon data-id="element-2691" />,
    title: 'Surveys and Commitments'
  }, {
    icon: <PieChartIcon data-id="element-2692" />,
    title: 'Client-Ready Reporting Dashboard'
  }];
  return <Section className="bg-white" data-id="element-2693">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2694">
        <FadeIn data-id="element-2695">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-2696">
            Everything needed to make the event feel intentional.
          </h2>
        </FadeIn>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-2697">
        {features.map((feature, i) => <FadeIn key={i} delay={i * 0.05} data-id="element-2698">
            <div className="bg-slate-50 border border-slate-100 rounded-xl p-5 flex flex-col items-center text-center h-full hover:bg-slate-100 transition-colors" data-id="element-2699">
              <div className="text-brand-teal mb-3" data-id="element-2700">
                {cloneElement(feature.icon as React.ReactElement, {
              className: 'w-6 h-6'
            })}
              </div>
              <h4 className="text-sm font-bold text-brand-navy" data-id="element-2701">
                {feature.title}
              </h4>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
}